import React from 'react'
import Styles from '../../../Css/View360/View360.module.css'
import View360CommonStyle from '../../../Css/View360/View360Common.module.css'
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import { checkIsV2 } from '../../../utils/getAppVersion';

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#000',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb': {
        backgroundColor: '#fff',
      },
        '& .MuiSwitch-thumb:before': {
          backgroundImage: `url('https://spyne-static.s3.us-east-1.amazonaws.com/black-hotspot.svg')`,
        },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#0000004D',
        // ...theme.applyStyles('dark', {
        //   backgroundColor: '#4600F2',
        // }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: '#000',
    width: 32,
    height: 32,
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('https://spyne-static.s3.us-east-1.amazonaws.com/white-hotspot.svg')`,
    },
    // ...theme.applyStyles('dark', {
    //   backgroundColor: '#003892',
    // }),
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: '#0000004D',
    borderRadius: 20 / 2,
    // ...theme.applyStyles('dark', {
    //   backgroundColor: '#8796A5',
    // }),
  },
}));

const MobileToggleHandler = ({isSpanish, handleHotSpotViewToggle, toggleHotspotView, initialHotspotProcessing, isInterior = false }) => {
    const isV2 = checkIsV2()
    
    // If we're processing an initial hotspot, ensure the switch is forced to ON state
    const effectiveToggleState = initialHotspotProcessing ? true : toggleHotspotView;
    
    return (
        <div 
            style={{right: '1%', bottom: '5.5%'}} 
            className={isInterior ? Styles['hotspot-info-tag-left-mobile-view-v3-interior'] : Styles['hotspot-info-tag-left-mobile-view-v3']}
            data-mobile-toggle-handler="true"
        >
            <MaterialUISwitch
                onChange={handleHotSpotViewToggle}
                checked={effectiveToggleState}
                disabled={initialHotspotProcessing} // Disable toggle while processing initial hotspot
                data-mobile-toggle-switch="true"
            />
        </div>
    )
}

export default MobileToggleHandler
